<template lang="pug">
  v-card(class="complex-card", outlined, @click="$emit('view-complex', complex.complexId)", :ripple="false", min-height=330)
    v-img(
      class="complex-card__image",
      height="180px"
      :src="!complex.photos.length ? require('@/assets/images/noimage.png') : complex.photos[0]")
    v-col
      span(class="complex-card__date") {{ moment(complex.creationDate).format('LL') }}
      h3(class="complex-card__name") {{ complex.companyName }}
      h3(class="complex-card__title") {{ complex.name }}
      div(class="complex-card__description") {{ complex.description }}
</template>

<script>
export default {
  name: 'ComplexCard',
  props: {
    complex: {
      type: Object,
      default: () => {},
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
.complex-card {
  border-radius: 6px;
  &__image {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
  }
  &__date {
    color: #456990;
    font-size: 10px;
    font-weight: 400;
    display: block;
  }
  &__title {
    color: #000;
    font-size: 18px;
    font-weight: 700;
    letter-spacing: -0.73 px;
    margin-bottom: 8px;
  }
  &__description {
    color: #8e8e93;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: -0.41 px;
    max-height: 48px;
    height: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  &:hover {
    cursor: pointer;
    box-shadow: 0 0 20px rgba(61, 90, 254, 0.4);
  }
}
</style>
